exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card {\n  margin-top: 1em;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  background-color: #ffffff;\n  height: 100%;\n  max-height: 450px;\n  overflow-y: scroll; }\n  .card .selected {\n    background-color: dodgerblue;\n    color: white; }\n    .card .selected .editIcon {\n      color: white; }\n  .card .iconColumn {\n    width: 85px; }\n  .card .icon {\n    float: left;\n    padding-top: 10px;\n    color: dodgerblue;\n    font-size: 18px;\n    cursor: pointer; }\n  .card .editIcon {\n    color: dodgerblue;\n    font-size: 22px; }\n  .card .deleteIcon {\n    padding-left: 10px;\n    color: red;\n    font-size: 22px;\n    float: right; }\n\n.input-group {\n  max-width: 350px; }\n  .input-group input[type='text'] {\n    border-right: white; }\n  .input-group .input-group-text {\n    color: dodgerblue;\n    background-color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/components/organisations/components/organizations-list/organizations-list.component.scss
// module id = 1277
// module chunks = 0